import { getLocale, getTimeZone } from 'next-intl/server'

import { browserEnvs } from '@/shared/envs'
import type {
  CommonDateFormatter,
  CommonDateFormatterWithTimeZone,
} from '@/shared/hooks/commonDateFormatter/commonDateFormatter.common'
import { getFormatDate } from '@/shared/hooks/commonDateFormatter/commonDateFormatter.common'
import { type Locale, getFullLocale, proofLocale } from '@/shared/locale'

export async function getCommonDateFormatter(): Promise<CommonDateFormatter>
export async function getCommonDateFormatter(
  timeZone: string | undefined,
): Promise<CommonDateFormatterWithTimeZone>
// eslint-disable-next-line func-style
export async function getCommonDateFormatter(timeZone?: string | undefined) {
  const country = browserEnvs.NEXT_PUBLIC_COUNTRY
  const [partialLocale, defaultTimeZone] = await Promise.all([getLocale(), getTimeZone()])

  const proofedLocale = proofLocale(partialLocale as Locale)
  const locale = getFullLocale(country, proofedLocale)
  return getFormatDate(locale, timeZone ?? defaultTimeZone)
}
